{
  "title": "الضمانات البنكية",
  "hint": "الضمانات التي قدمتها الشركة للعميل وتلك التي استلمتها من الموردين ومقاولي الباطن. تحتفظ المشاريع بالسجل وتذكّرك قبل انتهاء كل ضمان بـ {{days}} يومًا؛ أما التأمين النقدي ورسوم البنك فتُسجّل في المالية والمصروفات.",
  "add": "إضافة ضمان",
  "given": "مقدّمة",
  "received": "مستلمة",
  "openNamed": "فتح {{type}} {{reference}}",
  "loading": "جارٍ تحميل الضمان…",
  "edit": "تعديل",
  "empty": {
    "title": "لا توجد ضمانات بعد",
    "body": "أضف ضمان حسن التنفيذ وضمان الدفعة المقدمة عندما يصدرهما البنك.",
    "readOnly": "تظهر هنا الضمانات البنكية لهذا المشروع."
  },
  "mark": {
    "today": "ينتهي اليوم",
    "expiresIn_zero": "ينتهي اليوم",
    "expiresIn_one": "ينتهي بعد يوم واحد",
    "expiresIn_two": "ينتهي بعد يومين",
    "expiresIn_few": "ينتهي بعد {{n}} أيام",
    "expiresIn_many": "ينتهي بعد {{n}} يومًا",
    "expiresIn_other": "ينتهي بعد {{n}} يوم"
  },
  "status": {
    "ACTIVE": "ساري",
    "RELEASED": "مُفرج عنه",
    "CALLED": "مُسيَّل",
    "EXPIRED": "منتهي"
  },
  "type": {
    "BID": "ضمان ابتدائي",
    "PERFORMANCE": "ضمان حسن التنفيذ",
    "ADVANCE_PAYMENT": "ضمان الدفعة المقدمة",
    "RETENTION": "ضمان المحتجزات",
    "MAINTENANCE": "ضمان الصيانة"
  },
  "direction": {
    "GIVEN": "مقدّم",
    "RECEIVED": "مستلم"
  },
  "directionHint": {
    "GIVEN": "قدّمه بنكنا للعميل",
    "RECEIVED": "مستلم من مورد أو مقاول باطن"
  },
  "col": {
    "reference": "رقم الضمان",
    "project": "المشروع",
    "type": "النوع",
    "bank": "البنك",
    "counterparty": "الطرف الآخر",
    "amount": "المبلغ",
    "percent": "% من العقد",
    "expiry": "الانتهاء",
    "status": "الحالة",
    "bankCounterparty": "البنك · الطرف الآخر",
    "expiryStatus": "الانتهاء والحالة"
  },
  "form": {
    "newTitle": "ضمان جديد",
    "editTitle": "تعديل الضمان {{reference}}",
    "body": "كما ورد في خطاب البنك. تُسجَّل التمديدات والتخفيضات والإفراجات بعد ذلك كأحداث، مع خطاب البنك دليلًا.",
    "type": "النوع",
    "reference": "رقم الضمان",
    "referenceHint": "مرجع البنك في الخطاب.",
    "bank": "البنك",
    "beneficiary": "المستفيد",
    "issuer": "مقدَّم من",
    "amount": "المبلغ",
    "bondHint": "{{pct}} من القيمة الحالية للعقد تساوي {{amount}}.",
    "useProposed": "استخدامه",
    "margin": "التأمين النقدي",
    "marginHint": "ما يحتجزه البنك مقابله (للعلم فقط؛ تُحرّك المالية المبلغ).",
    "issueDate": "تاريخ الإصدار",
    "expiryDate": "تاريخ الانتهاء",
    "claimEnd": "آخر يوم للمطالبة",
    "claimEndHint": "فقط إذا اختلف عن تاريخ الانتهاء.",
    "notes": "ملاحظات",
    "save": "حفظ الضمان",
    "create": "إضافة الضمان",
    "error": {
      "amount": "أدخل مبلغًا أكبر من صفر.",
      "expiryOrder": "تاريخ الانتهاء قبل تاريخ الإصدار.",
      "margin": "لا يمكن أن يكون التأمين سالبًا.",
      "required": "مطلوب"
    }
  },
  "toast": {
    "saved": "تم حفظ الضمان",
    "added": "تمت إضافة الضمان {{reference}}"
  },
  "reducible": {
    "title": "قابل للتخفيض",
    "body": "المتبقي من الدفعة المقدمة {{amount}}: يجوز للعميل الموافقة على تخفيض هذا الضمان إليه.",
    "hint": "المتبقي من الدفعة المقدمة {{amount}}."
  },
  "events": {
    "actions": "سجّل ما قام به البنك",
    "title": "السجل",
    "none": "لا تغييرات منذ إصداره.",
    "called": "سُيِّل {{amount}}",
    "newAmount": "المبلغ الآن {{amount}}",
    "newExpiry": "ينتهي في {{date}}"
  },
  "event": {
    "EXTEND": "تمديد",
    "REDUCE": "تخفيض",
    "AMEND": "تعديل",
    "RELEASE": "إفراج",
    "CALL": "تسييل"
  },
  "eventDone": {
    "EXTEND": "مُدِّد",
    "REDUCE": "خُفِّض",
    "AMEND": "عُدِّل",
    "RELEASE": "أُفرج عنه",
    "CALL": "سُيِّل"
  },
  "eventTitle": {
    "EXTEND": "تمديد {{reference}}",
    "REDUCE": "تخفيض {{reference}}",
    "AMEND": "تعديل {{reference}}",
    "RELEASE": "الإفراج عن {{reference}}",
    "CALL": "تسجيل تسييل {{reference}}"
  },
  "eventHint": {
    "EXTEND": "مدّد البنك تاريخ الانتهاء. أرفق خطابه بالضمان.",
    "REDUCE": "خفّض البنك المبلغ، عادةً مع استرداد الدفعة المقدمة أو استلام الأعمال.",
    "AMEND": "غيّر البنك المبلغ أو تاريخ الانتهاء أو كليهما.",
    "RELEASE": "أُعيد الضمان إلى البنك، فلا يعود التزامًا محتملًا.",
    "CALL": "طالب المستفيد بقيمة الضمان. سجّل خصم البنك في المالية."
  },
  "eventBody": {
    "EXTEND": "ينتقل تاريخ الانتهاء من {{from}} إلى {{to}}، وتبدأ التذكيرات من جديد من التاريخ الجديد.",
    "REDUCE": "ينخفض المبلغ من {{from}} إلى {{to}}.",
    "AMEND": "يبقى الضمان على حالته؛ ما تدخله يحل محل المبلغ أو تاريخ الانتهاء.",
    "RELEASE": "يصبح {{reference}} مُفرجًا عنه: لا تذكيرات بعد الآن، ويخرج من الالتزامات المحتملة من هذا التاريخ.",
    "CALL": "يصبح الضمان مُسيَّلًا بمبلغ {{amount}}. لا يُرحَّل شيء هنا: يُسجَّل خصم البنك في المالية."
  },
  "eventForm": {
    "date": "التاريخ",
    "newExpiry": "تاريخ الانتهاء الجديد",
    "newAmount": "المبلغ الجديد",
    "calledAmount": "المبلغ المُسيَّل",
    "current": "الحالي {{amount}}.",
    "note": "ملاحظة",
    "noteHint": "ما حدث ومرجع البنك. كل تغيير يحتاج ملاحظة.",
    "noteRequired": "اذكر ما حدث.",
    "laterExpiry": "اختر تاريخًا بعد تاريخ الانتهاء الحالي.",
    "lowerAmount": "أدخل مبلغًا أقل من الحالي.",
    "calledInvalid": "أدخل مبلغًا أكبر من صفر ولا يزيد على مبلغ الضمان.",
    "amendSomething": "أدخل مبلغًا جديدًا أو تاريخ انتهاء جديدًا أو كليهما."
  },
  "eventToast": {
    "EXTEND": "تم تمديد {{reference}}",
    "REDUCE": "تم تخفيض {{reference}}",
    "AMEND": "تم تعديل {{reference}}",
    "RELEASE": "تم الإفراج عن {{reference}}",
    "CALL": "تم تسجيل تسييل {{reference}}"
  },
  "register": {
    "title": "الضمانات",
    "meta": "الضمانات البنكية لكل المشاريع، المقدّمة والمستلمة",
    "views": "عروض الضمانات",
    "tab": "السجل",
    "csv": "تصدير CSV",
    "csvFailed": "تعذّر التصدير. حاول مرة أخرى.",
    "empty": "لا توجد ضمانات مطابقة",
    "emptyBody": "غيّر البحث أو عوامل التصفية، أو أضف الضمانات من تبويب العقد › الضمانات في المشروع.",
    "count_zero": "لا ضمانات · السارية: المقدّمة {{given}}، والمستلمة {{received}}",
    "count_one": "ضمان واحد · السارية: المقدّمة {{given}}، والمستلمة {{received}}",
    "count_two": "ضمانان · السارية: المقدّمة {{given}}، والمستلمة {{received}}",
    "count_few": "{{n}} ضمانات · السارية: المقدّمة {{given}}، والمستلمة {{received}}",
    "count_many": "{{n}} ضمانًا · السارية: المقدّمة {{given}}، والمستلمة {{received}}",
    "count_other": "{{n}} ضمان · السارية: المقدّمة {{given}}، والمستلمة {{received}}",
    "clear": "مسح عوامل التصفية",
    "emptyNone": "لا توجد ضمانات بعد",
    "emptyNoneBody": "تُضاف الضمانات من تبويب العقد › الضمانات في المشروع."
  },
  "filter": {
    "any": "الكل",
    "direction": "الاتجاه",
    "type": "النوع",
    "status": "الحالة",
    "expiring": "ينتهي خلال",
    "days_zero": "اليوم",
    "days_one": "يوم واحد",
    "days_two": "يومين",
    "days_few": "{{n}} أيام",
    "days_many": "{{n}} يومًا",
    "days_other": "{{n}} يوم",
    "project": "المشروع",
    "search": "بحث",
    "searchPlaceholder": "رقم الضمان أو البنك أو الطرف الآخر",
    "clearSearch": "مسح البحث"
  },
  "contingent": {
    "tab": "الالتزامات المحتملة",
    "asOf": "في تاريخ",
    "hint": "الضمانات السارية في {{date}} بمبالغها كما كانت في ذلك اليوم (بعد احتساب التمديدات والتخفيضات والإفراجات والتسييلات).",
    "given": "المقدّمة",
    "givenHint": "ما ستدفعه البنوك لعملائنا إذا طالبوا: التزام محتمل.",
    "received": "المستلمة",
    "receivedHint": "ما يمكننا المطالبة به من بنوك الموردين ومقاولي الباطن.",
    "inForce": "السارية في ذلك التاريخ",
    "none": "لا شيء ساري.",
    "count": "العدد",
    "total": "الإجمالي"
  },
  "openProject": "فتح المشروع {{code}}",
  "percentOf": "{{pct}} من العقد"
}
